/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Chat_LabelInputs */

const en_us2_coaching_chat_label = /** @type {(inputs: Coaching_Chat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const pt_br2_coaching_chat_label = /** @type {(inputs: Coaching_Chat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem`)
};

const pt_pt2_coaching_chat_label = /** @type {(inputs: Coaching_Chat_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem`)
};

/** @type {(inputs: Coaching_Chat_LabelInputs) => LocalizedString} */
const es_419_coaching_chat_label = en_us2_coaching_chat_label;

/** @type {(inputs: Coaching_Chat_LabelInputs) => LocalizedString} */
const fr_fr2_coaching_chat_label = en_us2_coaching_chat_label;

/** @type {(inputs: Coaching_Chat_LabelInputs) => LocalizedString} */
const de_de2_coaching_chat_label = en_us2_coaching_chat_label;

/** @type {(inputs: Coaching_Chat_LabelInputs) => LocalizedString} */
const it_it2_coaching_chat_label = en_us2_coaching_chat_label;

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Coaching_Chat_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_chat_label = /** @type {((inputs?: Coaching_Chat_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Chat_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_chat_label(inputs)
	if (locale === "es-419") return es_419_coaching_chat_label(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_chat_label(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_chat_label(inputs)
	if (locale === "de-DE") return de_de2_coaching_chat_label(inputs)
	if (locale === "it-IT") return it_it2_coaching_chat_label(inputs)
	return en_us2_coaching_chat_label(inputs)
});
export { coaching_chat_label as "coaching.chat_label" }